<template>
  <Fragment>
    <template v-if="$route.name !== 'brandCategory'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>国家名称：</span>
              <el-input v-model="countryName"></el-input>
            </div>
            <el-button type="primary" class="ml-20" @click="searchCountry"
              >查询
            </el-button>
          </div>
          <el-button type="primary" class="mr-20" @click="addBrand"
            >新增品类或品牌</el-button
          >
        </section>
      </div>
      <el-row>
        <el-col :span="11"
          ><div class="grid-content bg-purple">
            <el-table :data="countryList" style="width: 100%" border>
              <el-table-column label="序号" width="60">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + (countryPageNum - 1) * countryPageSize + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="国家名称" width="180">
                <template slot-scope="scope">
                  <span
                    @click="getBrandInfoByOidCode(scope.row)"
                    style="color: #409EFF"
                    >{{ scope.row.baseDataCountryName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="OID编码" :fit="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.baseDataCountryOidCode }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20 pagination"
              background
              layout="total,prev, pager"
              :total="countryTotal"
              :page-size="10"
              :current-page="countryPageNum"
              @prev-click="handlePrePage"
              @next-click="handleNextPage"
              @current-change="handleCurrentChange"
            >
            </el-pagination></div
        ></el-col>
        <el-col :span="13"
          ><div class="grid-content bg-purple-light">
            <el-table :data="brandList" style="width: 100%" border>
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + (brandPageNum - 1) * brandPageSize + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数据类型" width="80">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.baseDataType === 1 ? "品牌" : "品类"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品牌或品类名称" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.brandClassName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品牌或品类OID码" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.brandClassOidCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" :fit="true">
                <template slot-scope="scope">
                  <span
                    @click="handleEditBrandInfo(scope.row)"
                    style="color: #409EFF"
                    >编辑</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20 pagination"
              background
              layout="total,prev, pager, next"
              :total="brandTotal"
              :page-size="10"
              :current-page="brandPageNum"
              @prev-click="brandHandlePrePage"
              @next-click="brandHandleNextPage"
              @current-change="brandHandleCurrentChange"
            >
            </el-pagination></div
        ></el-col>
      </el-row>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      countryName: "",
      countryList: [],
      countryPageNum: 1,
      countryPageSize: 10,
      countryTotal: 0,
      brandList: [],
      brandPageNum: 1,
      brandPageSize: 10,
      brandTotal: 0,
      countryOidCode: ""
    };
  },
  methods: {
    //左侧获取国家信息
    getCountryInfo() {
      let _this = this;
      let param = {
        url: "/api/country/getBaseDataCountryList",
        params: {
          baseDataCountryName: _this.countryName,
          pageNum: _this.countryPageNum,
          pageSize: _this.countryPageSize
        }
      };

      _this.$store.dispatch("getBaseDataCountryCodeList", param).then(() => {
        _this.countryList =
          _this.$store.state.country.baseDataCountryCodeList.list;
        _this.countryTotal =
          _this.$store.state.country.baseDataCountryCodeList.total;
      });
    },
    //左侧国家查询
    searchCountry() {
      let _this = this;
      _this.getCountryInfo();
    },
    //获取品牌信息列表
    getBrandInfoList() {
      let _this = this;
      let param = {
        url: "/api/countryBrand/getBrandInfoList",
        params: {
          baseDataCountryOidCode: _this.countryOidCode,
          pageNum: _this.brandPageNum,
          pageSize: _this.brandPageSize
        }
      };

      _this.$store.dispatch("getBrandInfoList", param).then(() => {
        _this.brandList = _this.$store.state.country.brandInfo.list;
        _this.brandTotal = _this.$store.state.country.brandInfo.total;
      });
    },
    //国家名称点击触发事件
    getBrandInfoByOidCode(row) {
      let _this = this;
      _this.countryOidCode = row.baseDataCountryOidCode;
      _this.getBrandInfoList();
    },
    //左侧当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.countryPageNum = value;
      _this.getCountryInfo();
    },
    //左侧上一页
    handlePrePage() {
      let _this = this;
      _this.countryPageNum -= 1;
      _this.getCountryInfo();
    },
    //左侧下一页
    handleNextPage() {
      let _this = this;
      _this.countryPageNum += 1;
      _this.getCountryInfo();
    },
    //右侧当前页
    brandHandleCurrentChange(value) {
      let _this = this;
      _this.brandPageNum = value;
      _this.getBrandInfoList();
    },
    //右侧上一页
    brandHandlePrePage() {
      let _this = this;
      _this.brandPageNum -= 1;
      _this.getBrandInfoList();
    },
    //右侧下一页
    brandHandleNextPage() {
      let _this = this;
      _this.brandPageNum += 1;
      _this.getBrandInfoList();
    },
    //添加品牌信息
    addBrand() {
      this.$router.push({
        name: "brandManage"
      });
    },
    //编辑品牌信息
    handleEditBrandInfo(row) {
      let _this = this;
      //获取国家
      let countryInfo = _this._.find(_this.countryList, function(item) {
        return item.baseDataCountryOidCode === row.baseDataCountryOidCode;
      });
      _this.$store.state.country.editBrandInfo = {
        countryName: countryInfo.baseDataCountryName,
        baseDataType: row.baseDataType,
        brandClassOidCode: row.brandClassOidCode,
        brandClassName: row.brandClassName
      };
      _this.$router.push({
        name: "brandManage",
        query: {
          id: row.id
        }
      });
    }
  },
  created() {
    let _this = this;
    _this.getCountryInfo();
    _this.getBrandInfoList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
      display: flex
      align-items: center
      justify-content: space-between

      .left
          display: flex

      .el-button
          font-size: 14px

      .search-name, .search-code
          font-size: 14px
          display: flex
          align-items: center

          span
              white-space: nowrap

  .pagination
      text-align: center
</style>
